<template>
  <div class="head-content">
    <div class="center-area">
  	  <p class="head-title">{{shengyaUser.studentName}}</p>
  	  <p>{{shengyaUser.studentCollege}}</p>
  	  <p>{{shengyaUser.studentMajor}}</p>
    </div>
    <div class="right-area">
  	  <p :class="status?'':'passed'">{{text}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
      id: Number
    },
  name: 'HeaderBox',
  data () {
    return {
      info:'',
      text:'恭喜通过此关',
      status:true,
      guanzhu:true
    }
  },
  computed:{
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    })
  },
  created(){
    this.getStatus()
  },
  methods: {
    // 检查关主状态
    guanzhuStatus(num){
       let invalid=true
       let object =JSON.parse(this.shengyaUser.admin.jsonSetting)
       if(num==1){
         if(object&&object.guanzhu){
           invalid=false
         }
         this.guanzhu = invalid
       }
       return invalid
    },
    //关主答疑
    emitEnterChat(){
      if(!this.guanzhu){
        this.$bus.$emit('enter-chat')
      }
    },
    //获取闯关状态
    getStatus(){
      if(this.id){
        if(this.shengyaUser.arrCosPlay[this.id-1]==-1){
          this.text = '遗憾闯关失败'
          this.status = false
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .head-content
    overflow:hidden
    margin: 0 0.2rem
  .left-img
    float:left
    width:1.2rem
    height:1.2rem
    border-radius:50%
    margin-top:0.4rem
  .center-area
    float:left
    font-size:0.24rem
    margin-top:0.3rem
    p
      margin:0.1rem
      line-height:0.3rem
    .head-title
      font-size:0.36rem
  .right-area
    float:right
    margin-right:0.2rem
    margin-top:0.5rem
    text-align:center
    p
      color:#DC6E5A
      font-weight:bold
      font-size:0.32rem
      margin-bottom:0.1rem
    .passed
      color:#00B3DE
    button
      background-color:#DC6E5A
      color:#ffffff
      padding:0.1rem
      border:none
      border-radius:0.12rem
      box-shadow:0
      font-size:0.28rem
    .invalid
      background-color:#BBBBBB
</style>
